import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"
import { getTokenLocal } from "../helper/utils"

export default class CustomerMangementAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // customer mangement
  assigned_unassigned = ApiRoutes.customerManagement.Assigned_UnAssignedGroups

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getAssignedAndUnAssignedGroups = (token: string, flag: any) => {
    return this.instance({
      method: this.assigned_unassigned.Method,
      url: this.assigned_unassigned.EndPoint(flag),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
}
